// @flow

import * as React from "react";
export const LanguageCtx: React$Context<[string, string]> = React.createContext<[string, string]>(['en-us', '']);
